// REACT
import React, { Component } from "react";
import { Accordion, Icon, Modal } from "semantic-ui-react";
import "./RemoteSensing.scss";
import * as helpers from "../../../helpers/helpers";

class NDMInterpretation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ndmi: props.ndmi,
      ndmiCategory: "",
      toggleActiveIndex: 1,
      categoryIndex: "",
    };
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      this.indexBorderValues = window.config.indexBorderValues_sk.ndmi;
    })
  }

  componentDidMount() {
    this.setState({
      ndmiCategory: "",
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ndmi !== this.props.ndmi) {
      this.setState({
        ndmi: this.props.ndmi,
      });

      const ndmiDict = Object.values(this.indexBorderValues);
      const ndmi = this.props.ndmi;
      let ndmiCategory = "";

      if (ndmi !== "") {
        let i = 0;
        for (; i < ndmiDict.length - 1; i++) {
          if (
            (ndmi > ndmiDict[i].borderValue) &
            (ndmi <= ndmiDict[i + 1].borderValue)
          ) {
            ndmiCategory = ndmiDict[i + 1].desc;
            this.setState({ categoryIndex: i + 1 });
            this.setState({ ndmiCategory });
          }
        }
      } else {
        this.setState({ ndmiCategory: "" });
        this.setState({ categoryIndex: 0 });
      }
    }
  }

  listOfIndexCategories = () => {
    return (
      <div>
        {this.indexBorderValues.map((item) => {
          if (item.id > 0) {
            return (
              <li
                key={item.id}
                className={
                  this.state.categoryIndex === item.id ? "activeCategory" : ""
                }
              >
                {item.desc}
              </li>
            );
          }
          return null;
        })}
      </div>
    );
  };

  onToggleFilter = () => {
    const newIndex = this.state.toggleActiveIndex === 1 ? 0 : 1;
    this.setState({ toggleActiveIndex: newIndex });
  };

  render() {
    return (
      <>
        <div className="ndviDesc">
          <strong>Interpretácia: </strong>
          {this.state.ndmiCategory}
        </div>
        <Accordion className="accordion">
          <Accordion.Title
            active={this.state.toggleActiveIndex === 0}
            index={0}
            onClick={this.onToggleFilter}
            className="accordionTitle"
          >
            <Icon name="dropdown" />
            <strong>Použitá kategorizácia</strong>
            {/* <Modal
              size={"tiny"}
              trigger={
                <img
                  src={images["info.png"]}
                  alt="loading"
                  style={{
                    position: "relative",
                    top: "3px",
                    height: "15px",
                    padding: "0 10px",
                  }}
                />
              }
              header="Použitá kategorizácia:"
              content="V odbornej literatúre je uvádzaných viacero spôsobov kategorizácie hodnôt indexu NDMI. Použitá kategorizácia bola prevzatá zo zdroja: https://www.agricolus.com/en/vegetation-indices-ndvi-ndmi/"
              actions={["Zavrieť"]}
            /> */}
          </Accordion.Title>
          <Accordion.Content active={this.state.toggleActiveIndex === 0}>
            <div className="NDVInterpretation">
              <ul>{this.listOfIndexCategories()}</ul>
            </div>
          </Accordion.Content>
        </Accordion>
      </>
    );
  }
}

export default NDMInterpretation;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("../../../sidebar/images", false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}